import React from "react";
import DotsHorizontalIcon from "mdi-react/DotsHorizontalIcon";
import { Menu, MenuItem, Popover } from "@blueprintjs/core";

const MoreActions = (props) => {
  const optionsMenu = (
    <Menu>
      <MenuItem
        onClick={() => {
          return props.onEditClicked
            ? props.onEditClicked(props.member)
            : undefined;
        }}
        text="Manage"
      />
      <MenuItem
        onClick={() => {
          return props.onEditClicked
            ? props.onSetPasswordClicked(props.member)
            : undefined;
        }}
        text="Set Password"
      />
    </Menu>
  );
  return (
    <div>
      <div className="more-details-ellipsis-container">
        <Popover content={optionsMenu} position="bottom">
          <DotsHorizontalIcon item={props.member} />
        </Popover>
      </div>
    </div>
  );
};

export default MoreActions;
